// ============================================================================
// BonBoZ: nhân viên nào đang xem những trang nào — bản đồ dùng chung cho bảng
// nhân viên (cột "Trang") và hộp sửa nhân viên (mục "Trang được xem", nút
// "Giống như <người>"). Issue #147.
//
// Lưu xong ở hộp sửa thì ghi thẳng kết quả server trả về vào đây để cột trong
// bảng đổi ngay, không GET lại cả bảng.
// ============================================================================
import { ref } from 'vue';
import NhanVienAPI from 'dashboard/api/bonboz/nhanVien';

/**
 * { "<user_id>": [inbox_id, ...] }.
 * `null` = CHƯA NẠP / NẠP HỎNG, khác hẳn `{}` = nạp xong, không ai có trang.
 * Nơi hiển thị phải phân biệt hai trạng thái này: `trangCua` trả `[]` cho cả
 * hai, và "0/10 trang" tô hổ phách cho MỌI nhân viên khi API lỗi là nói dối.
 */
export const bangTrang = ref(null);

export const napBangTrang = () =>
  NhanVienAPI.bangTrang()
    .then(({ data }) => {
      bangTrang.value = data || {};
    })
    .catch(() => {
      // Hỏng thì giữ `null`: cột "Trang" để trống (xem agents/Index.vue) chứ
      // không chặn màn nhân viên.
    });

export const trangCua = userId =>
  (bangTrang.value?.[String(userId)] || []).map(Number);

export const datTrangCua = (userId, inboxIds) => {
  bangTrang.value = { ...(bangTrang.value || {}), [String(userId)]: inboxIds };
};
